<template>
  <div class="home-layout">
    <TopNav />

    <!-- 嵌套路由的出口 -->
    <main class="main-content">
      <router-view />
    </main>

    <footer class="footer">
      <div class="footer-container">
        <div class="footer-grid">
          <div class="footer-brand">
            <div class="logo" v-if="settingInfo && settingInfo.site_name">
              <div class="logo-icon">
                <i class="iconfont icon-shipin" />
              </div>
              {{ settingInfo.site_name || '' }}
            </div>
            <p>{{ $t('HomeLayout.下一代AI视频生成平台') }}</p>
          </div>

          <div class="footer-links">
            <h4>{{ $t('HomeLayout.产品') }}</h4>
            <ul>
              <li><a href="#/ai">{{ $t('HomeLayout.AI视频') }}</a></li>
              <li><a href="#/price">{{ $t('HomeLayout.价格方案') }}</a></li>
              <li>
                <router-link to="/news">
                  {{ $t('HomeLayout.新闻资讯') }}
                </router-link>
              </li>
            </ul>
          </div>

          <div class="footer-links">
            <h4>{{ $t('HomeLayout.支持') }}</h4>
            <ul>
              <li><a @click="handleEmail" style="cursor: pointer;">{{ $t('HomeLayout.帮助中心') }}</a></li>
              <li><a @click="handleNone" style="cursor: pointer;">{{ $t('HomeLayout.API文档') }}</a></li>
              <li><a href="#/FAQ">{{ $t('HomeLayout.常见问题') }}</a></li>
            </ul>
          </div>

          <div class="footer-links">
            <h4>{{ $t('HomeLayout.法律') }}</h4>
            <ul>
              <li v-for="item in ArticleList" :key="item.id">
                <a :href="`#/article?id=${item.id}`">{{ item.name }}</a>
              </li>
            </ul>
          </div>
        </div>

        <div class="footer-bottom" v-if="settingInfo && settingInfo.site_banquan">{{ settingInfo.site_banquan }}</div>
      </div>
    </footer>

    <!-- 回到顶部按钮 -->
    <transition name="fade">
      <div v-show="showBackToTop" class="back-to-top" @click="scrollToTop">
        <i class="el-icon-arrow-up" />
      </div>
    </transition>

    <!-- 分享模态框 -->
    <el-dialog :title="$t('HomeLayout.客服邮箱')" :visible.sync="emailVisible" width="450px" center
      custom-class="share-dialog" :before-close="closeEmail">
      <div class="share-content">
        <div class="share-link">
          <el-input ref="shareInput" :value="settingInfo.site_email" readonly class="share-input"
            v-if="settingInfo && settingInfo.site_email" />
          <div class="copy-btn" @click="copyEmail">
            <i class="el-icon-document-copy" /> {{ $t('HomeLayout.复制邮箱') }}
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import TopNav from '@/components/TopNav.vue'
import { getArticleCategoriesApi } from '@/api/api'

export default {
  name: 'HomeLayout',
  components: {
    TopNav
  },
  data() {
    return {
      email: '',
      showBackToTop: false,

      emailVisible: false,

      ArticleList: []
    }
  },
  computed: {
    ...mapState(['settingInfo']),
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)

    getArticleCategoriesApi().then(res => {
      this.ArticleList = res.data
    }).catch(() => { })
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleNone() {
      this.$message.warning(this.$t('HomeLayout.开发中'))
    },
    handleEmail() {
      if (this.settingInfo && this.settingInfo.site_email) {
        this.emailVisible = true
      }
    },
    closeEmail() {
      this.emailVisible = false
    },
    copyEmail() {
      const input = this.$refs.shareInput.$el.querySelector('input')
      if (input) {
        input.select()
        document.execCommand('copy')
        this.$message.success(this.$t('HomeLayout.链接已复制到剪贴板'))
      }
    },
    handleScroll() {
      this.showBackToTop = window.scrollY > 300
    },
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.home-layout {
  min-height: 100vh;
  display: flex;
  flex-direction: column;

  .main-content {
    flex: 1;
  }
}

.footer {
  padding: 4rem 2rem 2rem;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  background: rgba(0, 0, 0, 0.4);
  backdrop-filter: blur(10px);
  margin-top: auto;

  .footer-container {
    max-width: 1200px;
    margin: 0 auto;

    .footer-grid {
      display: grid;
      grid-template-columns: 2fr repeat(3, 1fr);
      gap: 2rem;
      margin-bottom: 3rem;

      .footer-brand {
        .logo {
          display: flex;
          align-items: center;
          gap: 0.75rem;
          font-size: 1.5rem;
          font-weight: 700;
          margin-bottom: 1rem;
          background: linear-gradient(135deg, #6366f1, #a855f7);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;

          .logo-icon {
            width: 40px;
            height: 40px;
            background: linear-gradient(135deg, #6366f1, #a855f7);
            border-radius: 12px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 1.25rem;
            -webkit-text-fill-color: white;
          }
        }

        p {
          color: #64748b;
          max-width: 300px;
          line-height: 1.6;
          margin-bottom: 1rem;
          font-size: 0.875rem;
        }
      }

      .footer-links {
        h4 {
          font-size: 1rem;
          font-weight: 600;
          margin-bottom: 1.25rem;
          color: #e2e8f0;
          position: relative;
          display: inline-block;
        }

        ul {
          list-style: none;

          li {
            margin-bottom: 0.75rem;

            a {
              color: #64748b;
              text-decoration: none;
              transition: all 0.3s;
              font-size: 0.875rem;

              &:hover {
                color: #f1f5f9;
                padding-left: 4px;
              }
            }
          }
        }
      }
    }

    .footer-bottom {
      padding-top: 2rem;
      border-top: 1px solid rgba(255, 255, 255, 0.08);
      color: #64748b;
      font-size: 0.875rem;
      text-align: center;
    }
  }
}

// 回到顶部按钮
.back-to-top {
  position: fixed;
  bottom: 2rem;
  right: 2rem;
  width: 44px;
  height: 44px;
  background: linear-gradient(135deg, #6366f1, #a855f7);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s;
  z-index: 1000;
  box-shadow: 0 4px 12px rgba(99, 102, 241, 0.3);

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 6px 16px rgba(99, 102, 241, 0.4);
  }

  i {
    font-size: 1.25rem;
    color: white;
  }
}

// 动画
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

// 响应式
@media (max-width: 1024px) {
  .footer {
    .footer-grid {
      grid-template-columns: repeat(2, 1fr) !important;
      gap: 2rem !important;
    }
  }
}

@media (max-width: 768px) {
  .footer {
    padding: 2rem 1rem 1.5rem;

    .footer-container {
      .footer-grid {
        grid-template-columns: 1fr !important;
        gap: 1.5rem !important;
      }
    }
  }

  .back-to-top {
    bottom: 1rem;
    right: 1rem;
    width: 38px;
    height: 38px;
  }
}
</style>